import script from "./SettingsCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsCompany.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import FormElement from "@/components/neue/FormElement.vue";
import FormSection from "@/components/neue/FormSection.vue";
import ImageUploaderNeue from "@/components/neue/ImageUploaderNeue.vue";
import InputArea from "@/components/neue/InputArea.vue";
import InputField from "@/components/neue/InputField.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import NeueToggle from "@/components/neue/NeueToggle.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
import TheModal from "@/components/TheModal.vue";
script.components = Object.assign({}, { FormElement, FormSection, ImageUploaderNeue, InputArea, InputField, NeueButton, NeueToggle, SelectInput, SettingsSection, TheModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { FormElement, FormSection, ImageUploaderNeue, InputArea, InputField, NeueButton, NeueToggle, SelectInput, SettingsSection, TheModal }, script.__o.components);}